<div [className]="mobile ? 'info-box-mobile' : 'info-box'" [fxLayoutAlign]="'left center'">
  <i nz-icon class="suffix-info" nzType="info-circle" nzTheme="fill"></i>
  <span><ng-content></ng-content></span>
</div>
